module.exports = __webpack_public_path__ + "img/login_img.fa7647e6.png";